import { fetchSharingUrlsListApi } from 'api/sharingContentApi'
import { SharingType } from 'components/block/SharingContent/SharingContent.constant'

import { AsyncAction } from '../actions.types'

export const FETCH_SHARING_URL_LIST = 'FETCH_SHARING_URL_LIST' as const

export interface FetchSharingUrlListAction extends AsyncAction<Response> {
  type: typeof FETCH_SHARING_URL_LIST
}

export const fetchSharingUrlListAction = (
  sharingType: SharingType,
  contentId: number,
  profileId: number
): FetchSharingUrlListAction => ({
  type: FETCH_SHARING_URL_LIST,
  promise: () => fetchSharingUrlsListApi(sharingType, contentId, profileId),
})

interface Response {
  contentIdentity: {
    type: string
    contentId: number
    ownerId: number
  }
  urls: {
    sharingMethod: string
    url: string
  }[]
}
